/**
 * Filter-URL's: max. één tag per groep in het pad (Shopify = AND).
 * Extra selecties binnen dezelfde groep (OR) via ?uf_sel=group|tag.
 * Zoekpagina: geen pad-tags (voorkomt 0 server-resultaten).
 */
(function (win) {
  'use strict';

  function isSearchMode(root) {
    return !!(root && root.getAttribute('data-uf-search') === 'true');
  }

  function basePathFromAttr(baseRaw) {
    return String(baseRaw || '').split('?')[0].replace(/\/$/, '');
  }

  function checkedByGroup(root) {
    var byGroup = {};
    if (!root) return byGroup;
    root.querySelectorAll('.uf-filter-checkbox:checked').forEach(function (b) {
      var g = b.getAttribute('data-group');
      var tag = String(b.getAttribute('data-tag') || '').trim();
      var handle = String(b.getAttribute('data-tag-handle') || '').trim();
      if (!g || !tag || !handle) return;
      if (!byGroup[g]) byGroup[g] = [];
      byGroup[g].push({ group: g, tag: tag, handle: handle });
    });
    Object.keys(byGroup).forEach(function (g) {
      byGroup[g].sort(function (a, b) {
        return a.handle.localeCompare(b.handle);
      });
    });
    return byGroup;
  }

  function pathHandlesFromCheckboxes(root) {
    if (isSearchMode(root)) return [];
    var byGroup = checkedByGroup(root);
    var handles = [];
    Object.keys(byGroup).sort().forEach(function (g) {
      if (byGroup[g].length) handles.push(byGroup[g][0].handle);
    });
    handles.sort();
    return handles;
  }

  function allHandlesFromCheckboxes(root) {
    var h = [];
    if (!root) return h;
    root.querySelectorAll('.uf-filter-checkbox:checked').forEach(function (b) {
      var th = b.getAttribute('data-tag-handle');
      if (th) h.push(th);
    });
    h.sort();
    return h;
  }

  function handlesFromPathname(baseRaw) {
    var p = win.location.pathname || '';
    var b = basePathFromAttr(baseRaw);
    if (p === b || p === b + '/') return [];
    var prefix = b + '/';
    if (p.indexOf(prefix) !== 0) return [];
    var rest = p.slice(prefix.length).split('?')[0];
    if (!rest) return [];
    try {
      rest = decodeURIComponent(rest);
    } catch (e1) {}
    return rest.split('+').filter(Boolean).map(function (s) {
      return s.trim();
    }).sort();
  }

  function sameSortedArray(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  function parseSelParam(raw) {
    var s = String(raw || '').trim();
    if (!s) return null;
    var pipe = s.indexOf('|');
    if (pipe < 1) return null;
    return {
      group: s.slice(0, pipe),
      tag: s.slice(pipe + 1)
    };
  }

  function selectionListFromParams(params) {
    var list = [];
    if (!params || typeof params.getAll !== 'function') return list;
    params.getAll('uf_sel').forEach(function (raw) {
      var p = parseSelParam(raw);
      if (p) list.push(p);
    });
    if (!params.getAll('uf_sel').length) {
      var legacyGroup = String(params.get('uf_group') || '').trim();
      var legacyTag = String(params.get('uf_tag') || '').trim();
      if (legacyGroup && legacyTag) {
        list.push({ group: legacyGroup, tag: legacyTag });
      }
    }
    return list;
  }

  function canonicalSelList(root) {
    var list = [];
    var byGroup = checkedByGroup(root);
    var search = isSearchMode(root);
    Object.keys(byGroup).sort().forEach(function (g) {
      var items = byGroup[g];
      var start = search ? 0 : 1;
      for (var i = start; i < items.length; i++) {
        list.push({ group: g, tag: items[i].tag });
      }
    });
    list.sort(function (a, b) {
      return (a.group + '\0' + a.tag).localeCompare(b.group + '\0' + b.tag);
    });
    return list;
  }

  function sameSelectionList(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (a[i].group !== b[i].group || a[i].tag !== b[i].tag) return false;
    }
    return true;
  }

  function clearSelectionParams(url) {
    url.searchParams.delete('uf_group');
    url.searchParams.delete('uf_tag');
    url.searchParams.delete('uf_sel');
    url.searchParams.delete('uf_path_tags');
    url.searchParams.delete('uf_h');
  }

  function applySelectionsToUrl(url, root) {
    clearSelectionParams(url);
    canonicalSelList(root).forEach(function (item) {
      url.searchParams.append('uf_sel', item.group + '|' + item.tag);
    });
  }

  function buildFilterUrl(root, sortBy, href) {
    var url = new URL(href || win.location.href);
    url.searchParams.delete('page');
    clearSelectionParams(url);
    if (sortBy) url.searchParams.set('sort_by', String(sortBy));
    else url.searchParams.delete('sort_by');

    if (root) {
      var baseRaw = root.getAttribute('data-collection-base');
      if (baseRaw) {
        var base = basePathFromAttr(baseRaw);
        var handles = pathHandlesFromCheckboxes(root);
        url.pathname = handles.length ? base + '/' + handles.join('+') : base;
      }
      applySelectionsToUrl(url, root);

      var minEl = document.getElementById('uf-price-min');
      var maxEl = document.getElementById('uf-price-max');
      if (minEl && maxEl) {
        var aMin = parseInt(minEl.min, 10);
        var aMax = parseInt(maxEl.max, 10);
        var minV = parseInt(minEl.value, 10);
        var maxV = parseInt(maxEl.value, 10);
        if (isFinite(minV) && isFinite(aMin) && minV > aMin) url.searchParams.set('uf_pmin', String(minV));
        else url.searchParams.delete('uf_pmin');
        if (isFinite(maxV) && isFinite(aMax) && maxV < aMax) url.searchParams.set('uf_pmax', String(maxV));
        else url.searchParams.delete('uf_pmax');
      }
    }
    return url;
  }

  function needsLegacySearchRedirect(root, baseRaw) {
    if (!isSearchMode(root)) return false;
    if (handlesFromPathname(baseRaw).length > 0) return true;
    try {
      return handlesFromLegacyQuery(new URLSearchParams(win.location.search || '')).length > 0;
    } catch (e) {
      return false;
    }
  }

  function pathHasMultipleInSameGroup(root, baseRaw) {
    var params = null;
    try {
      params = new URLSearchParams(win.location.search || '');
    } catch (eP) {}
    var handles = mergedPathHandles(baseRaw, params);
    if (handles.length <= 1) return false;
    var counts = {};
    root.querySelectorAll('.uf-filter-checkbox').forEach(function (b) {
      var th = b.getAttribute('data-tag-handle');
      var g = b.getAttribute('data-group');
      if (!th || !g || handles.indexOf(th) === -1) return;
      counts[g] = (counts[g] || 0) + 1;
    });
    for (var g in counts) {
      if (counts[g] > 1) return true;
    }
    return false;
  }

  function canonicalUrlFromRoot(root, sortBy) {
    var built = buildFilterUrl(root, sortBy || 'manual', win.location.href);
    built.searchParams.delete('page');
    return built.pathname + built.search + built.hash;
  }

  function hasFilterDeeplinkParams() {
    try {
      var q = new URLSearchParams(win.location.search || '');
      if (q.getAll('uf_sel').length) return true;
      if (handlesFromLegacyQuery(q).length) return true;
      return !!(String(q.get('uf_group') || '').trim() && String(q.get('uf_tag') || '').trim());
    } catch (e) {
      return false;
    }
  }

  function applyPathHandlesToCheckboxes(root, baseRaw) {
    var params;
    try {
      params = new URLSearchParams(win.location.search || '');
    } catch (eP) {
      params = null;
    }
    applyHandlesToCheckboxes(root, mergedPathHandles(baseRaw, params));
  }

  function handlesFromLegacyQuery(params) {
    var handles = [];
    if (!params || typeof params.get !== 'function') return handles;
    var pts = String(params.get('uf_path_tags') || '').trim();
    if (pts) {
      pts.split('+').forEach(function (h) {
        h = String(h || '').trim();
        if (h) handles.push(h);
      });
    }
    if (typeof params.getAll === 'function') {
      params.getAll('uf_h').forEach(function (h) {
        h = String(h || '').trim();
        if (h) handles.push(h);
      });
    }
    handles.sort();
    return handles;
  }

  function mergedPathHandles(baseRaw, params) {
    var merged = handlesFromPathname(baseRaw).concat(handlesFromLegacyQuery(params));
    var seen = {};
    var out = [];
    merged.forEach(function (h) {
      if (!h || seen[h]) return;
      seen[h] = true;
      out.push(h);
    });
    out.sort();
    return out;
  }

  function applyHandlesToCheckboxes(root, handles) {
    if (!root || !handles || !handles.length) return;
    var handleSet = {};
    for (var hi = 0; hi < handles.length; hi++) handleSet[handles[hi]] = true;
    root.querySelectorAll('.uf-filter-checkbox').forEach(function (b) {
      var th = b.getAttribute('data-tag-handle');
      if (th && handleSet[th]) b.checked = true;
    });
  }

  function applySelectionParamsToCheckboxes(root, params) {
    var list = selectionListFromParams(params);
    if (!list.length) return;
    if (!params.getAll('uf_sel').length && list.length === 1) {
      root.querySelectorAll('.uf-filter-checkbox').forEach(function (b) {
        if (b.getAttribute('data-group') === list[0].group) b.checked = false;
      });
    }
    list.forEach(function (item) {
      root.querySelectorAll('.uf-filter-checkbox').forEach(function (b) {
        if (b.getAttribute('data-group') !== item.group) return;
        var dt = String(b.getAttribute('data-tag') || '').trim();
        if (dt === item.tag) b.checked = true;
      });
    });
  }

  win.UfFilterUrl = {
    isSearchMode: isSearchMode,
    basePathFromAttr: basePathFromAttr,
    checkedByGroup: checkedByGroup,
    pathHandlesFromCheckboxes: pathHandlesFromCheckboxes,
    allHandlesFromCheckboxes: allHandlesFromCheckboxes,
    handlesFromPathname: handlesFromPathname,
    sameSortedArray: sameSortedArray,
    selectionListFromParams: selectionListFromParams,
    canonicalSelList: canonicalSelList,
    sameSelectionList: sameSelectionList,
    buildFilterUrl: buildFilterUrl,
    needsLegacySearchRedirect: needsLegacySearchRedirect,
    pathHasMultipleInSameGroup: pathHasMultipleInSameGroup,
    canonicalUrlFromRoot: canonicalUrlFromRoot,
    hasFilterDeeplinkParams: hasFilterDeeplinkParams,
    handlesFromLegacyQuery: handlesFromLegacyQuery,
    applyPathHandlesToCheckboxes: applyPathHandlesToCheckboxes,
    applySelectionParamsToCheckboxes: applySelectionParamsToCheckboxes
  };
})(window);
